<template>
  <section class="full-loading" v-show="$store.state.loading"></section>
</template>
<script>
export default {
  name: 'FullLoading'
}
</script>

<style lang="scss">
.full-loading {
  z-index: 999;
  background: rgba(255, 255, 255, 0.01);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;

  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    span {
      font-size: 30px;
      text-transform: uppercase;
      color: var(--v-primary-base);
      display: block;
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>
